import { Auth } from 'aws-amplify';


export function formatSubmittedRule(formRuleSubmission){
    let rule = Object.assign({}, formRuleSubmission);
    let worktags = {};
    rule.worktags.forEach(worktagPair => worktags[worktagPair.key] = worktagPair.value);
    rule.worktags = worktags;
    rule.tran_account = rule.tran_account || `${rule.type_code}:${rule.bank_account}`;
    rule.components = rule.components || `${rule.customer_ref || ""}:${rule.orig_id || ""}:${rule.ind_id_no || ""}:${rule.bo_customer || ""}:${rule.vrn || ""}`;
    rule.components_search = rule.components_search || `CUSTREF${rule.customer_ref || ""}:ORIGID${rule.orig_id || ""}:INDIDNO${rule.ind_id_no || ""}:BOCUSTOMER${rule.bo_customer || ""}:VRN${rule.vrn || ""}`;
    return rule;
}

export function toTitleCase(string){
    let newString;
    if(!string.match(/[a-z]/)){
        //CONSTANT_CASE
        newString = string.replace(/_/g, c => " ");
    } else {
        //camelCase
        newString = string.replace(/[A-Z]/g, c => ` ${c}`);
    }
    return newString.replace(/\w\S*/g, c => c.charAt(0).toUpperCase() + c.substr(1).toLowerCase())
}

export function findRuleInRules(idOfRule, rules){
    return rules.find((rule) => rule.id === idOfRule) || false;
}

export function findRuleIndex(idOfRule, rules){
    let rule = findRuleInRules(idOfRule, rules);
    return rules.indexOf(rule);
}

export function redirectToLogIn(){

    const{
        userPoolWebClientId,
        oauth
    } = Auth.configure();

    window.location.assign('https://' + oauth.domain
                            + '/oauth2/authorize?'
                            + 'identity_provider='+oauth.idp
                            + '&redirect_uri=' + oauth.redirectSignIn
                            + '&response_type=' + oauth.responseType
                            + '&client_id=' + userPoolWebClientId
                            + '&' + oauth.scope.join(" "));
}

export function makeAllObjectValesAString(object) {
    Object.keys(object).forEach((key) => {
      if (typeof object[key] === 'object') {
        return toString(object[key]);
      }
      
      object[key] = '' + object[key];
    });
    
    return object;
  }


// WEBPACK FOOTER //
// ./src/util/util.js